import { Link } from 'react-router-dom';

import type { DocSummary } from '../model/docs.type';

interface DocsPagerProps {
  prev?: DocSummary | null;
  next?: DocSummary | null;
}

const CARD =
  'rounded-xl border border-neutral-200 px-4 py-3.5 transition-colors hover:border-brand-300 dark:border-white/12 dark:hover:border-brand-500/40';

/** 이전/다음. 섹션 경계를 넘어 매니페스트 순서를 따른다 — 그 순서가 곧 학습 순서다. */
export function DocsPager({ prev, next }: DocsPagerProps) {
  if (!prev && !next) return null;

  return (
    <nav aria-label="문서 이동" className="mt-11 grid gap-3.5 sm:grid-cols-2">
      {prev ? (
        <Link to={prev.path} className={CARD}>
          <span className="mb-1 block text-[11.5px] text-neutral-400">← 이전</span>
          <span className="block text-sm text-neutral-700 dark:text-neutral-200">
            {prev.title}
          </span>
        </Link>
      ) : (
        <span className="hidden sm:block" />
      )}
      {next && (
        <Link to={next.path} className={`${CARD} sm:text-right`}>
          <span className="mb-1 block text-[11.5px] text-neutral-400">다음 →</span>
          <span className="block text-sm text-neutral-700 dark:text-neutral-200">
            {next.title}
          </span>
        </Link>
      )}
    </nav>
  );
}
